import React, { Component } from "react";
import Header from './../../Header';
import Loader from './../../Loader';
import Menu from './../../Menu';
import './../../../assets/css/chief-complain.css';
import {CONFIG, jsUcfirst, checkAuth} from './../../../helpers/Common';
import {QUESTION} from './../../../services/Questions';
import {SURGEON} from '../../../services/Surgeon';
import NextPrev from "./NextPrev";

class ChiefComplain extends Component {

    constructor(props)
    {
        super(props);
        this.state = {
            complainTypes:'',
            _complainTypes:'',
            complainTypeId:'',
            numberOfDays : 1,
            month : 1,
            isLoading : true,
            selectedComplains : new Array(),
            selectedTab:"",
            nextStep : 3,
            complainTypeDetails : '',
            title:'Select Secondary Complain'
        };
        this.selectComplainType     = this.selectComplainType.bind(this);
        this.handleAction           = this.handleAction.bind(this);
        this.handleChange           = this.handleChange.bind(this);
        this.disableTab             = this.disableTab.bind(this);
        this.checkAuth              = checkAuth.bind(this)// Import from common
    }

    componentWillMount()
    {
        checkAuth();
        let _complainTypes = "";
        let QuestionsData = QUESTION.getChiefComplainTypes().then(res => {
            if(res.data.header.error==0)
            {

                let complainTypes       = res.data.body.details;
                let _complainTypes      = res.data.body.details;

                complainTypes           = new Array(Math.ceil(complainTypes.length / 5)).fill().map(_ => complainTypes.splice(0,5));
                this.setState({
                    complainTypes: complainTypes,
                    _complainTypes: _complainTypes,

                });
            }
        }).catch(err => {
            return err;
        });



        SURGEON.getPatientComplains(this.props.patientId).then(res => {
            if(res.data.header.error==0)
            {
                let selectedComplains       = res.data.body.details;
                let ref = this;
                Object.values(selectedComplains).forEach(function(row,key)
                {
                    let _selectedComplains = ref.state.selectedComplains;
                    _selectedComplains.push(row.id);
                    ref.setState({
                        selectedComplains: _selectedComplains
                    });

                })

            }

        }).catch(err => {
            return err;
        });




        let complainData = this.props.getComplainData;
        this.setState({
            isLoading     : false
        })
        if(complainData)
        {
            this.setState({
                complainTypeId  : complainData.complain_types,
            })
        }

        if(localStorage.getItem('data'))
        {
            this.setState({
                title     : 'Select Secondary Complain'
            })
        }

    }

    selectComplainType = (e) =>
    {
        let selectedComplains = this.state.selectedComplains;
        // selectedComplains.push(parseInt(e.target.dataset.id));
        this.setState({
            complainTypeId      : e.target.dataset.id,
            selectedComplains   : selectedComplains,
            selectedTab         : e.target.dataset.id

        });
    }

    handleAction = (e) => {
        if(this.state.complainTypeId)
        {
            let saveData            = new Array();
            let complainTypeDetails = new Array();
            let complainId          = this.state.complainTypeId;
            Object.values(this.state.complainTypes).forEach(function(row,key)
            {
                Object.values(row).forEach(function(row2,key2)
                {

                    if(parseInt(complainId) == row2.id)
                    {
                        complainTypeDetails = row2;
                    }

                })

            })
            saveData = ({
                complain_types:this.state.complainTypeId,
                month:this.state.month,
                number_of_days: this.state.numberOfDays,
                complainTypeDetails:complainTypeDetails
            });
            console.log('This is the all saveData in chiefcomplain .js',saveData)
            this.props.setComplainData(saveData);
            this.props.setComplainLocation("");
            this.props.handleNextPrevSteps(this.state.nextStep);
        }
        else
        {
            alert('Please select Complain Type');
        }
    }

    handleChange = (e) =>{
        if(e.target.value > 0){
            this.setState({
                [e.target.name]: e.target.value,
              });
        }
    }

    getData = (e) =>{
        return this.state.complainTypeId
    }

    disableTab = (id) =>
    {
        let selectedComplains = this.state.selectedComplains;

        if(this.props.isModify)
        {
            if(selectedComplains.indexOf(id)==-1)
            {
                return true;
            }
        }
        else
        {
            if(selectedComplains.indexOf(id)!=-1)
            {
                return true;
            }
        }

        return false;

    }

    render() {

        return (
            <React.Fragment>
                <Header title={this.state.title} titleImage="ic-band-aid.png" />
                <Menu />
                <section className="chief-complain">
                    <div className="male-model-complain">
                        <div className="container">
                            <div className="male-img">
                                <img src={require('./../../../assets/img/content-img/male-img.png')} alt="" />
                                {
                                    this.state.isLoading!=0 &&
                                    <Loader/>
                                }
                                <div className="complain-buttons">
                                    <div className="complain-buttons">
                                        {Object.values(this.state.complainTypes).map((row, key) => (
                                            <div className={key%2==0 ? 'left-btn' :'right-btn'} key={key}>
                                            {Object.values(row).map((row2, key2) => (
                                                <a onClick={this.selectComplainType} key={key2} href="javascript:void(0)" data-id={`${row2.id}`} className={`btn btn-custom  ${row2.name} ${this.state.selectedTab == (row2.id) ? 'is--active':''} ${this.disableTab(row2.id) == true ? 'is--disable':''}`}>{row2.name}</a>
                                            ))}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="complain-time">
                        <div className="container">
                            {/* <div className="complain-detail">
                                <div className="c-content">
                                    <h2>{CONFIG.WHEN_EXPERIENCED_PROBLEM}</h2>
                                </div>
                                <div className="form-group">
                                    <input name="numberOfDays" onChange={this.handleChange} type="text" value={this.state.numberOfDays} />
                                    <select name="month" onChange={this.handleChange}>
                                    {CONFIG.MONTHS.map((val, index) =>
                                    <option key={index+1} value={index+1}>{jsUcfirst(val)}</option>
                                    )};
                                    </select>
                                </div>
                            </div> */}
                        </div>
                    </div>
                </section>
                <NextPrev handleNextAction={this.handleAction} next={this.props.next} prev={this.props.prev} />
            </React.Fragment>
        );
    }
}

export default ChiefComplain;